export default function isInViewport(element: HTMLElement, bottomIntersect = 200) {
	const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
	if (vw <= 768) {
		bottomIntersect = 100;
	}

	const rect = element?.getBoundingClientRect();

	return (
		rect?.top >= -50 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + bottomIntersect
	);
}
